// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"fc1edce7","142":"cc1e7243","232":"d8a8643d","308":"4d9c0dca","346":"54ec2efa","400":"274ffb45","670":"c964eb55","915":"1306d57a"}[chunkId] + ".chunk.js";
};